import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import axios from "axios";
import { Constant, imageDomain } from "../../../helper/Constants.js";

class CourseItemGrid extends Component {
  state = {
    courses: [],
    page: 1,
    limit: 8,
    totalPages: 1,
    loading: false,
  };

  componentDidMount() {
    this.fetchCourses(1);
  }

  componentDidUpdate(prevProps) {
  if (prevProps.activeFilter !== this.props.activeFilter) {
    this.fetchCourses(1);
  }
}


  // Remove HTML & shorten text
  cleanText = (html = "") => {
    if (!html) return "";
    const text = html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  };

  // Build correct image URL
  buildImageUrl = (img) => {
    if (!img) return process.env.PUBLIC_URL + "/assets/images/default-course.jpg";
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? "" : "/") + img;

    return process.env.PUBLIC_URL + "/" + img;
  };

  fetchCourses = async (page = 1) => {
  this.setState({ loading: true });

  try {
    const { limit } = this.state;
    const { activeFilter } = this.props;

    const baseUrl =
      (Constant.getUrls && Constant.getUrls.getAllCourses) || "/api/courses";

    const filterParam =
      activeFilter && activeFilter !== "all"
        ? `&course_type=${activeFilter}`
        : "";

    const resp = await axios.get(
      `${baseUrl}?page=${page}&limit=${limit}${filterParam}`
    );

    const payload = resp?.data?.data || resp?.data || {};
    const docs = Array.isArray(payload.docs)
      ? payload.docs
      : Array.isArray(payload)
      ? payload
      : [];

    const totalDocs = payload.totalDocs || payload.total || docs.length || 0;
    const totalPages =
      payload.totalPages ||
      payload.totalpage ||
      Math.ceil(totalDocs / limit);

    this.setState({
      courses: docs,
      page,
      totalPages,
      loading: false,
    });
  } catch (error) {
    console.error("Failed to fetch courses", error);
    this.setState({ courses: [], loading: false });
  }
};


  // fetchCourses = async (page = 1) => {
  //   this.setState({ loading: true });

  //   try {
  //     const { limit } = this.state;
  //     const baseUrl =
  //       (Constant.getUrls && Constant.getUrls.getAllCourses) || "/api/courses";

  //     const resp = await axios.get(`${baseUrl}?page=${page}&limit=${limit}`);

  //     const payload = resp?.data?.data || resp?.data || {};
  //     const docs =
  //       Array.isArray(payload.docs) ? payload.docs : Array.isArray(payload) ? payload : [];
  //     const totalDocs = payload.totalDocs || payload.total || docs.length || 0;
  //     const totalPages =
  //       payload.totalPages ||
  //       payload.totalpage ||
  //       (limit ? Math.ceil(totalDocs / limit) : 1);

  //     this.setState({
  //       courses: docs,
  //       page: payload.page || page,
  //       totalPages: totalPages || 1,
  //       loading: false,
  //     });
  //   } catch (error) {
  //     console.error("Failed to fetch courses", error);
  //     this.setState({ courses: [], loading: false });
  //   }
  // };

  handlePageChange = (newPage) => {
    const { totalPages } = this.state;
    if (newPage < 1 || newPage > totalPages) return;
    this.fetchCourses(newPage);
  };

  render() {
    const { courses, page, totalPages, loading } = this.state;

    return (
      <Fragment>
        {/* Course Items */}
        {loading ? (
          <Col md="12">
            <p>Loading courses...</p>
          </Col>
        ) : courses.length > 0 ? (
          courses.map((data, i) => {
            const link = `/course-details/${data._id}`;
            const title = data.course_name || "Untitled Course";
            const price =
              typeof data.price === "number" ? `₹ ${data.price}` : data.price || "₹ 0";
            const desc = this.cleanText(data.description || "");
            const image = this.buildImageUrl(data.image);

            return (
              <Col lg="4" md="6" sm="12" key={data._id || i}>
                <div className="course-item">
                  <Link to={process.env.PUBLIC_URL + link}>
                    <div
                      className="course-image"
                      style={{
                        backgroundImage: `url(${image})`,
                      }}
                    >
                      <div className="author-img d-flex">
                        <div className="img">
                          <img
                            src={
                              process.env.PUBLIC_URL + `/assets/images/author.jpg`
                            }
                            alt="Author"
                          />
                        </div>
                        <div className="title">
                          <p>Admin</p>
                          <span>Courses</span>
                        </div>
                      </div>
                      <div className="course-price">
                        <p>{price}</p>
                      </div>
                    </div>
                  </Link>

                  <div className="course-content">
                    <h6 className="heading">
                      <Link to={process.env.PUBLIC_URL + link}>{title}</Link>
                    </h6>
                    <p className="desc">{desc}</p>

                    <div className="course-face d-flex justify-content-between">
                      <div className="duration">
                        <p>
                          <i className="las la-clock" /> {data.duration || "N/A"}
                        </p>
                      </div>

                      <div className="rating">
                        <ul className="list-unstyled list-inline">
                          <li className="list-inline-item">
                            <i className="las la-star"></i>
                          </li>
                          <li className="list-inline-item">
                            <i className="las la-star"></i>
                          </li>
                          <li className="list-inline-item">
                            <i className="las la-star"></i>
                          </li>
                          <li className="list-inline-item">
                            <i className="las la-star"></i>
                          </li>
                          <li className="list-inline-item">
                            <i className="las la-star-half-alt"></i>
                          </li>
                          <li className="list-inline-item">
                            ({data.rating ?? 4.5})
                          </li>
                        </ul>
                      </div>

                      <div className="student">
                        <p>
                          <i className="las la-chair"></i>
                          {data.enrolled || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })
        ) : (
          <Col md="12">
            <p>No courses found!</p>
          </Col>
        )}

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <Col md="12" className="text-center mt-4">
            <div className="course-pagination">
              <button
                className="btn btn-sm btn-outline-primary mr-2"
                disabled={page === 1}
                onClick={() => this.handlePageChange(page - 1)}
              >
                Prev
              </button>

              <span className="mx-2">
                Page {page} of {totalPages}
              </span>

              <button
                className="btn btn-sm btn-outline-primary ml-2"
                disabled={page === totalPages}
                onClick={() => this.handlePageChange(page + 1)}
              >
                Next
              </button>
            </div>
          </Col>
        )}
      </Fragment>
    );
  }
}

export default CourseItemGrid;
